module.exports = __webpack_public_path__ + "static/img/BS.bc90e96d.png";